import { SharedService } from "./../../../common/shared.service";
import { Component, OnInit } from "@angular/core";
import { LayoutCss } from "../../../modules/basico/layout-css/layout-css";

@Component({
  selector: "app-template",
  templateUrl: "./template.component.html",
  styleUrls: ["./template.component.css"],
})
export class TemplateComponent implements OnInit {
  layout: LayoutCss;
  constructor(private shared: SharedService) {}

  ngOnInit() {
    this.layout = this.shared.layout;
  }
}
